var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Grafik"},[_c('h2',[_vm._v("Grafik")]),_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }